<app-stages [stages]="stages" currentStage="Obsługa komunikacyjna"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class="col-md-4">
        <div class='form-group' *ngIf='"publicRoadAccess" as controlName'>
          <label [for]='controlName'>
            Dostęp do drogi publicznej *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.publicRoadAccessList; track $index) {
              <option [value]='item'>
                {{ item }}
              </option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Dostęp do drogi publicznej poprzez działki
      </legend>
      <app-parcels-crud
        tag="parcels2"
        [parcelIdControl]="true"
        [hideContentControl]="true"
        formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <div class="row">
      <div class="col-12">
        <div class='form-group' *ngIf='"publicRoadAccessAdditionalInfo" as controlName'>
          <label [for]='controlName'>
            Dodatkowe informacje dotyczące dostępu do drogi publicznej
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu dodatkową informacje'>
            </textarea>
          <app-validation-errors
            [showTextLength]="true"
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend class="d-flex justify-content-center">
        Wnioskowana liczba miejsc do parkowania
      </legend>
      <fieldset>
        <legend>
          Garaż <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"garageParkingExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca liczba miejsc
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"garageParkingPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (minimalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"garageParkingPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (maksymalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Parking <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"parkingLotExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca liczba miejsc
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"parkingLotPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (minimalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"parkingLotPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (maksymalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Inne <small>(jeśli dotyczy)</small>
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"otherParkingExisting" as controlName'>
              <label [for]='controlName'>
                Istniejąca liczba miejsc
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"otherParkingPlannedMin" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (minimalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"otherParkingPlannedMax" as controlName'>
              <label [for]='controlName'>
                Projektowana liczba miejsc (maksymalna)
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę miejsc'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class='form-group' *ngIf='"parkingAdditionalInfo" as controlName'>
              <label [for]='controlName'>
                Dodatkowe informacje dotyczące miejsc do parkowania
              </label>
              <textarea
                rows="3"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu dodatkową informacje'>
            </textarea>
              <app-validation-errors
                [showTextLength]="true"
                [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
